import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { LegalForm } from './legal-form.interface';

export class LegalFormService {
   async getLegalForms() {
      return await http.get<Array<LegalForm>>(`/legal_forms`, cacheFirstConfig).then((response: any) => response.data);
   }
}
